import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";

const routeSeo = {
  "/": [
    "Fina Interiors | Furniture & Interior Design in Pune",
    "Shop furniture and create personalized residential interiors with Fina Interiors in Pune, Maharashtra.",
  ],
  "/fina-interiors-catalogue": [
    "Furniture Catalogue | Fina Interiors",
    "Explore the Fina Interiors catalogue for sofas, chairs, beds, tables, wardrobes and home furniture.",
  ],
  "/fina-interiors-categories": [
    "Furniture Categories | Fina Interiors",
    "Browse furniture categories from Fina Interiors and find pieces suited to every room and style.",
  ],
  "/fina-interiors-home-interior-services": [
    "Home Interior Design Services in Pune | Fina Interiors",
    "Plan your home with Fina Interiors through personalized design, execution, furniture and furnishing services in Pune.",
  ],
  "/about-us": [
    "About Fina Interiors",
    "Learn about Fina Interiors and our approach to thoughtful furniture and functional interior design.",
  ],
  "/contact-us": [
    "Contact Fina Interiors | Pune",
    "Contact Fina Interiors in Hadapsar, Pune for furniture, interior design enquiries and project assistance.",
  ],
  "/get-quote": [
    "Request an Interior Design Quote | Fina Interiors",
    "Tell Fina Interiors about your space and request a personalized furniture or interior design quote.",
  ],
  "/Sales-Service-Task-Force": [
    "Sales and Service Support | Fina Interiors",
    "Connect with the Fina Interiors sales and service team for furniture and interior project support.",
  ],
  "/blogs": [
    "Interior Design Ideas & Guides | Fina Interiors",
    "Read furniture guides, interior design ideas and practical inspiration from Fina Interiors.",
  ],
  "/track-your-order": [
    "Track Your Order | Fina Interiors",
    "Track your Fina Interiors furniture order and view its latest delivery progress.",
  ],
  "/shipping-policy": ["Shipping Policy | Fina Interiors", "Read the Fina Interiors shipping and delivery policy."],
  "/privacy-policy": ["Privacy Policy | Fina Interiors", "Read how Fina Interiors collects, uses and protects customer information."],
  "/terms-and-condition": ["Terms and Conditions | Fina Interiors", "Read the terms and conditions for using Fina Interiors services and website."],
};

const privatePrefixes = [
  "/cart",
  "/checkout",
  "/payment-verify",
  "/address",
  "/update-address",
  "/success",
  "/dashboard",
  "/update-profile",
  "/recent-orders",
  "/orders-detail",
  "/wishlist",
  "/review",
];

const humanize = (value) =>
  decodeURIComponent(value || "")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const SeoManager = () => {
  const { pathname } = useLocation();
  const configured = routeSeo[pathname];
  const slug = pathname.split("/").filter(Boolean).pop();
  const isPrivate = privatePrefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

  let title = configured?.[0] || "Fina Interiors | Furniture & Interior Design";
  let description =
    configured?.[1] ||
    "Explore furniture and personalized interior design solutions from Fina Interiors in Pune.";

  if (pathname.startsWith("/category/") || pathname.startsWith("/sub-category/")) {
    title = `${humanize(slug)} Furniture | Fina Interiors`;
    description = `Shop ${humanize(slug)} furniture from Fina Interiors and find designs for your home.`;
  } else if (pathname.startsWith("/single-product/")) {
    title = "Product Details | Fina Interiors";
    description = "View furniture details, pricing and related products from Fina Interiors.";
  } else if (pathname.startsWith("/blog-detailing-page/")) {
    title = `${humanize(slug)} | Fina Interiors`;
    description = `Read ${humanize(slug)} from Fina Interiors.`;
  } else if (isPrivate) {
    title = `${humanize(slug)} | Fina Interiors`;
  }

  return (
    <Seo
      title={title}
      description={description}
      path={pathname}
      noindex={isPrivate}
    />
  );
};

export default SeoManager;
